import React from "react";
import { Helmet } from "react-helmet-async";

const AboutMe = () => {
  return (
    <main className="px-6 py-28 text-slate-200 md:px-12 lg:px-24">
      <Helmet>
        <title>About | Gabriel E.</title>
      </Helmet>

      <section id="about" className="mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <p className="mb-4 text-sm font-medium uppercase tracking-[0.35em] text-cyan-400">
            About Me
          </p>

          <h1 className="text-4xl font-bold tracking-tight text-slate-100 md:text-6xl">
            I build backend-heavy full-stack systems.
          </h1>

          <p className="mt-6 text-lg leading-8 text-slate-400">
            I&apos;m a Software Engineer with a Computer Science degree and 5
            years of industry experience across backend development,
            full-stack development, test automation, cloud infrastructure, and
            internal engineering tools.
          </p>

          <p className="mt-5 text-lg leading-8 text-slate-400">
            My strongest work is in Python, FastAPI, PostgreSQL, React,
            TypeScript, AWS, Redis, and automation systems. I enjoy building
            APIs, optimizing database queries, designing scalable backend
            workflows, and creating tools that help engineering teams move
            faster.
          </p>

          <p className="mt-5 text-lg leading-8 text-slate-400">
            Recently, I&apos;ve focused on network management platforms,
            SONiC-based automation, device discovery, telemetry workflows,
            dashboard integrations, CI/CD pipelines, and production reliability.
            I like working close to real systems where performance, debugging,
            and clean architecture matter.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 shadow-2xl shadow-slate-950/40">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-cyan-400">
              Backend
            </p>

            <p className="mt-4 text-sm leading-7 text-slate-400">
              FastAPI services, REST APIs, PostgreSQL schemas, Redis caching,
              pagination, filtering, background workflows, and performance
              optimization.
            </p>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 shadow-2xl shadow-slate-950/40">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-cyan-400">
              Full Stack
            </p>

            <p className="mt-4 text-sm leading-7 text-slate-400">
              React and TypeScript dashboards connected to backend APIs for
              automation workflows, visibility, reporting, and internal
              engineering tools.
            </p>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 shadow-2xl shadow-slate-950/40">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-cyan-400">
              Automation
            </p>

            <p className="mt-4 text-sm leading-7 text-slate-400">
              Test automation, GitLab CI/CD, TestRail integrations, Playwright,
              device workflows, logging, failure tracking, and production
              troubleshooting.
            </p>
          </div>
        </div>

        <div className="mt-12 rounded-2xl border border-slate-800 bg-slate-900/60 p-6 shadow-2xl shadow-slate-950/40 md:p-8">
          <h2 className="text-sm font-semibold uppercase tracking-[0.25em] text-cyan-400">
            Technologies I work with
          </h2>

          <div className="mt-6 flex flex-wrap gap-3">
            {[
              "Python",
              "FastAPI",
              "PostgreSQL",
              "React",
              "TypeScript",
              "Redis",
              "AWS",
              "Kubernetes",
              "GitLab CI/CD",
              "Playwright",
              "TestRail",
              "System Design",
            ].map((skill) => (
              <span
                key={skill}
                className="rounded-full border border-slate-700 bg-slate-950/50 px-4 py-2 text-sm text-slate-400 transition hover:border-cyan-400/50 hover:text-cyan-300"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutMe;
